import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CollectionPageComponent} from './containers/collection-page/collection-page.component';
import {ProductPageComponent} from './containers/product-page/product-page.component';
import {ProductExistsGuard} from './services/product-exists.guard';

const routes: Routes = [
    {
        path: '',
        component: CollectionPageComponent
    },
    {
        path: 'filter/:filterdata',
        component: CollectionPageComponent,
    },
    {
        path: 'filter/:filterdata/sort/:sortdata',
        component: CollectionPageComponent,
    },
    {
        path: 'sort/:sortdata',
        component: CollectionPageComponent,
    },
    {
        path: 'sort/:sortdata/filter/:filterdata',
        component: CollectionPageComponent,
    },
    {
        path: 'search/:searchdata',
        component: CollectionPageComponent,
    },
    {
        path: 'search/:searchdata/filter/:filterData',
        component: CollectionPageComponent,
    },
    {
        path: 'filter/:filterdata/search/:searchdata',
        component: CollectionPageComponent,
    },
    {
        path: 'filter/:filterdata/sort/:sortdata/search/:searchdata',
        component: CollectionPageComponent,
    },
    {
        path: 'sort/:sortdata/filter/:filterdata/search/:searchdata',
        component: CollectionPageComponent,
    },
    {
        path: 'filter/:filterdata/search/:searchdata/sort/:sortdata',
        component: CollectionPageComponent,
    },
    {
        path: ':id',
        component: ProductPageComponent,
        canActivate: [ProductExistsGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProductsRoutingModule {
}
